import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { DataSourceFolderWithSubfoldersSchema } from './data-sources-folders.schema';
import { CreateDataSourceSubfolderSchema } from './data-sources-subfolders.schema';

const { DATA_SOURCE } = PERMISSIONS;

/**
 * REST contract for DataSourceSubfolder operations
 */
export const DataSourceSubfoldersContract = createRESTContract({
  /**
   * Create a new DataSourceSubfolder
   */
  createDataSourceSubfolder: {
    method: 'POST',
    path: '/data-sources-subfolders',
    permissions: [DATA_SOURCE.DATA_SOURCE_CREATE_SUBFOLDER],
    body: CreateDataSourceSubfolderSchema,
    response: z.array(DataSourceFolderWithSubfoldersSchema),
  },

  /**
   * Delete a DataSourceSubfolder
   */
  deleteDataSourceSubfolder: {
    method: 'DELETE',
    path: '/data-sources-subfolders/:dataSourceSubfolderId',
    permissions: [DATA_SOURCE.DATA_SOURCE_DELETE_SUBFOLDER],
    body: z.undefined(),
    response: z.array(DataSourceFolderWithSubfoldersSchema),
  },
});
